module.exports = {
  __depends__: [ require(217) ],
  __init__: [ 'bpmnReplacePreview' ],
  bpmnReplacePreview: [ 'type', require(76) ]
};
